export default {
    REMOVE: 'REMOVE_ITEM',
    TEXT: 'INPUT_TEXT',
    TEXTSOLO: 'INPUT_TEXTSOLO',
    LABEL: 'INPUT_LABEL',
    TEXT_INT: 'INPUT_TEXT_INT',
    TEXT_FLOAT: 'INPUT_TEXT_FLOAT',
    TEXTAREA: 'INPUT_TEXTAREA',
    CHECKBOX: 'INPUT_CHECKBOX',
    SELECT: 'INPUT_SELECT',
    IMAGE: 'INPUT_IMAGE',
    GROUP: 'INPUT_GROUP'
}